<div class="modal-header">
  <h3 class="modal-title">Achtung Liefertermin prüfen!</h3>
</div>

<div class="modal-body">
  Bitte prüfen Sie die Liefertermine der ausgewählten Abrufe.
  Die Produktionszeit der Auswahl reicht für die Standard Produktionszeit nicht aus.

  <div>&nbsp;</div>

  <table class="table">
    <thead>
      <tr>
        <th colspan="3">Fehlerhafte Abrufe</th>
      </tr>
      <tr>
        <th>Abruf</th>
        <th>AT</th>
        <th>Eildienst</th>
      </tr>
    </thead>
    <tbody>
      @for (error of errors; track error) {
        <tr>
          <td>{{ error.fetch }}</td>
          <td>{{ error.at }}</td>
          <td>@if (error.express) {
            <i class="fa fa-check"></i>
          }</td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="modal-footer">
  <button class="btn btn-default pull-left" type="button" (click)="close()">
    Abbrechen
  </button>


  <loading-button clazz="btn btn-success pull-right" (loadingSave)="force($event)">
    Auft.-Best. trotzdem erstellen
  </loading-button>
  <workflow-position-missing-gold-price labelHeader="Artikel aus Auf.-Best. hat die Oberfläche &quot;Chem NI/AU&quot;,
   aber es gibt keine Goldpreis Position auf der Auf.-Best."
                                        labelCheckbox="Auftragsbestätigung trotzdem erstellen"
                                        labelButton="Auf.-Best. erstellen"
                                        [modalOpen]="showGoldPriceMissingModal"
                                        (response)="handleGoldPriceMissingModalClose($event)">
  </workflow-position-missing-gold-price>
</div>
